import { render, staticRenderFns } from "./AssetAssociationsModal.vue?vue&type=template&id=48b56304&"
import script from "./AssetAssociationsModal.vue?vue&type=script&lang=js&"
export * from "./AssetAssociationsModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetAssociationsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports